import React from "react";
import { Chart } from "react-google-charts";
import numbro from "numbro";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import NoData from "../../../components/noData/noData";

const accentColor = getComputedStyle(document.body).getPropertyValue("--color-accent").trim();

const options = {
  sliceVisibilityThreshold: 0,
  backgroundColor: { fill: "transparent" },
  pieSliceBorderColor: "transparent",
  colors: ["#ff664e", "#1794ca", "#21e981", "#df30e5", "#1cdac4", "#7d4eff", "#ffbe4e", "#ca5317"],
  tooltip: {
    trigger: "selection",
    textStyle: {
      fontSize: 14,
      bold: true,
      color: "#8791A0"
    }
  },
  chartArea: { left: 0, top: 20, width: "80%", height: "75%" },
  legend: {
    textStyle: {
      color: "#8791A0",
      fontSize: 16,
      bold: true
    },
    pagingTextStyle: {
      color: accentColor
    },
    scrollArrows: {
      activeColor: accentColor
    }
  }
};

const processData = (data, maxSegments) => {
  const sortedData = data.slice(1).sort((a, b) => {
    let num1 = numbro.unformat(a[1]);
    let num2 = numbro.unformat(b[1]);
    return num2 - num1;
  });

  const topSegments = sortedData.slice(0, maxSegments);
  const otherSegments = sortedData.slice(maxSegments);

  const otherTotal = otherSegments.reduce((sum, [, value]) => sum + numbro.unformat(value), 0);

  const processedData = [
    data[0],
    ...topSegments,
    ...(otherTotal > 0 ? [["Other", otherTotal]] : [])
  ];

  return processedData;
};

const PieCharts = ({ data = [], title }) => {
  const processedData = processData(data, 7);

  return (
    <div data-testid="pie-chart">
      <h5 className="pie-chart__title">{title}</h5>
      {processedData.length > 1 ? (
        <Chart
          loader={<LoadingAnimation text="Loading" />}
          chartType="PieChart"
          data={processedData}
          options={options}
          width="330px"
        />
      ) : (
        <NoData />
      )}
    </div>
  );
};

export default PieCharts;
